import { render, staticRenderFns } from "./NavDesktopMarketing.vue?vue&type=template&id=2dc89126&scoped=true&"
import script from "./NavDesktopMarketing.vue?vue&type=script&lang=js&"
export * from "./NavDesktopMarketing.vue?vue&type=script&lang=js&"
import style0 from "./NavDesktopMarketing.vue?vue&type=style&index=0&id=2dc89126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc89126",
  null
  
)

export default component.exports